module.exports = __webpack_public_path__ + "assets/img/Approval Matrix.fa28243b.svg";